export default __webpack_public_path__ + "static/media/conexito.dcad2ca4.png";